<template>
  <div class="evaluate">
    <div class="title">精彩评论（{{ evaluateData.length }}）</div>
    <div v-for="(item, index) in evaluateData" :key="item.name+index" class="e-item">
      <div class="imgbox">
        <img :src="item.img" alt="" />
      </div>
      <div class="msgBox">
        <div class="name">{{ item.name }}</div>
        <div class="msg">{{ item.msg }}</div>
        <div class="time">{{ item.time }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EvaluateBox",
  props: {},
  data() {
    return {
      evaluateData: [],
      evaluateDataAll: [
        {
          img: "https://avatars.githubusercontent.com/u/507615?s=40&v=4",
          name: "招财树开花了！",
          msg: "太精彩了，看了片尾，觉的更精彩！",
          time: "2022-04-21",
        },
        {
          img: "https://avatars.githubusercontent.com/u/7843281?s=40&v=4",
          name: "翩然入君怀",
          msg: "很喜欢，真的很适合孩子！",
          time: "2022-04-21 12:31",
        },
        {
          img: "https://avatars.githubusercontent.com/u/8186664?s=40&v=4",
          name: "吃樱桃",
          msg: "小时候自己能看到这个多好，只能给孩子看了，希望孩子能珍惜幸福！",
          time: "2022-03-30",
        },
        {
          img: "https://avatars.githubusercontent.com/u/29775873?s=40&v=4",
          name: "茉茉茉风吹雪香",
          msg: "太精彩了，看了片尾，觉的更精彩！",
          time: "2022-02-28",
        },
        {
          img: "https://avatars.githubusercontent.com/u/50612752?s=40&v=4",
          name: "白云浮云火烧云",
          msg: "推荐其他家长去看看，这真的不错，强烈推荐！",
          time: "2022-02-28",
        },
        {
          img: "https://avatars.githubusercontent.com/u/5526096?s=40&v=4",
          name: "ECHO爱吃荔枝",
          msg: "真的很好看，强烈推荐给小朋友们！",
          time: "2022-02-27",
        },
        {
          img: "https://avatars.githubusercontent.com/u/23628650?s=40&v=4",
          name: "擅长清空的猫",
          msg: "推荐其他家长去看看，这真的不错，强烈推荐！",
          time: "2021-12-28",
        },
        {
          img: "https://avatars.githubusercontent.com/u/5526096?s=40&v=4",
          name: "Talkaholic_L",
          msg: "很好看啊，很有意义！施诗！",
          time: "2021-12-27",
        },
        {
          img: "https://avatars.githubusercontent.com/u/28616219?s=40&v=4",
          name: "最後的最後..  ",
          msg: "小时候自己能看到这个多好，只能给孩子看了，希望孩子能珍惜幸福！",
          time: "2021-12-30",
        },
        {
          img: "https://avatars.githubusercontent.com/u/507615?s=40&v=4",
          name: "招财树开花了！",
          msg: "太精彩了，看了片尾，觉的更精彩！",
          time: "2021-12-28",
        },
        {
          img: "https://avatars.githubusercontent.com/u/7843281?s=40&v=4",
          name: "翩然入君怀",
          msg: "很喜欢，真的很适合孩子！",
          time: "2021-12-31 12:31",
        },
        {
          img: "https://avatars.githubusercontent.com/u/14918822?s=40&v=4",
          name: "天饿一孑 ",
          msg: "我最喜欢了，解放了家长。提升了孩子...",
          time: "2021-12-31 ",
        },
        {
          img: "https://avatars.githubusercontent.com/u/8358236?s=40&v=4",
          name: "开心的豆豆妈妈",
          msg: "很喜欢，真的很适合孩子！",
          time: "昨日 12:31",
        },
        {
          img: "https://avatars.githubusercontent.com/u/5378891?s=40&v=4",
          name: "。不忘初心_ ",
          msg: "我最喜欢了，解放了家长。提升了孩子...",
          time: "2021-12-31 ",
        },
        {
          img: "https://avatars.githubusercontent.com/u/8186664?s=40&v=4",
          name: "萨门下小宝",
          msg: "小时候自己能看到这个多好，只能给孩子看了，希望孩子能珍惜幸福！",
          time: "2021-12-30",
        },
        {
          img: "https://avatars.githubusercontent.com/u/29775873?s=40&v=4",
          name: "茉茉茉风吹雪香",
          msg: "太精彩了，看了片尾，觉的更精彩！",
          time: "2021-12-28",
        },
        {
          img: "https://avatars.githubusercontent.com/u/50612752?s=40&v=4",
          name: "白云浮云火烧云",
          msg: "推荐其他家长去看看，这真的不错，强烈推荐！",
          time: "2021-12-28",
        },
        {
          img: "https://avatars.githubusercontent.com/u/5526096?s=40&v=4",
          name: "ECHO爱吃荔枝",
          msg: "很好看啊，很有意义！施诗！在此刷新了，推荐！",
          time: "2021-12-27",
        },
        {
          img: "https://avatars.githubusercontent.com/u/507615?s=40&v=4",
          name: "招财树开花了！",
          msg: "太精彩了，看了片尾，觉的更精彩！",
          time: "2022-04-21",
        },
        {
          img: "https://avatars.githubusercontent.com/u/7843281?s=40&v=4",
          name: "翩然入君怀",
          msg: "很喜欢，真的很适合孩子！",
          time: "2022-04-21 12:31",
        },
        {
          img: "https://avatars.githubusercontent.com/u/8186664?s=40&v=4",
          name: "名字劲2",
          msg: "小时候自己能看到这个多好，只能给孩子看了，希望孩子能珍惜幸福！",
          time: "2022-03-30",
        },
        {
          img: "https://avatars.githubusercontent.com/u/29775873?s=40&v=4",
          name: "茉茉茉风吹雪香",
          msg: "太精彩了，看了片尾，觉的更精彩！",
          time: "2022-02-28",
        },
        {
          img: "https://avatars.githubusercontent.com/u/50612752?s=40&v=4",
          name: "白云浮云火烧云",
          msg: "推荐其他家长去看看，这真的不错，强烈推荐！",
          time: "2022-02-28",
        },
        {
          img: "https://avatars.githubusercontent.com/u/5526096?s=40&v=4",
          name: "ECHO爱吃荔枝",
          msg: "很好看啊，很有意义！施诗！",
          time: "2022-02-27",
        },
        {
          img: "https://i3.letvimg.com/lc02_user/201607/29/15/36/14697778023008_50_50.png",
          name: "爱生活",
          msg: "想起好多事",
          time: "2022-03-27",
        },
        {
          img: "https://i1.letvimg.com/lc03_user/201511/11/13/06/14472183785842_50_50.jpg",
          name: "俗咖___260",
          msg: "强烈推荐",
          time: "2022-03-29",
        },
        {
          img: "https://i0.letvimg.com/lc03_webtv/201509/05/21/32/1441459933585.jpg",
          name: "新用户567955_814",
          msg: "精彩",
          time: "2022-05-29",
        },
      ],
    };
  },
  watch: {
    $route: {
      handler() {
        console.log(1223333)
        this.evaluateData = this.getRandomArray(this.evaluateDataAll, 6);
      },
      deep: true,
    },
  },
  created() {
    this.evaluateData = this.getRandomArray(this.evaluateDataAll, 6);
  },
  methods: {
    getRandomArray(arr, num) {
      var temp_array = new Array();
      for (var index in arr) {
        temp_array.push(arr[index]);
      }

      var return_array = new Array();
      for (var i = 0; i < num; i++) {
        if (temp_array.length > 0) {
          var arrIndex = Math.floor(Math.random() * temp_array.length);
          return_array[i] = temp_array[arrIndex];
          temp_array.splice(arrIndex, 1);
        } else {
          break;
        }
      }
      return return_array;
    },
  },
};
</script>

<style lang="scss" scoped>
.evaluate {
  height: 100%;
  float: left;
  margin-right: 450px;
  padding: 30px 0;
  .title {
    height: 20px;
    font-size: 20px;
    line-height: 20px;
    color: #18191e;
    margin-bottom: 30px;
  }
  .e-item {
    display: flex;
    margin-bottom: 20px;
    .imgbox {
      width: 54px;
      height: 54px;
      margin-right: 16px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
    .msgBox {
      .name {
        font-size: 15px;
        color: #18191e;
        opacity: 0.6;
        filter: alpha(opacity=60);
        transition: color 0.2s;
        margin-bottom: 7px;
      }
      .msg {
        margin-bottom: 5px;
        font-size: 15px;
        line-height: 27px;
        word-wrap: break-word;
      }
      .time {
        margin-right: 40px;
        font-size: 13px;
        color: #18191e;
        opacity: 0.6;
        filter: alpha(opacity=60);
      }
    }
  }
}
</style>